<template>
    <div id="green-bar" :class="[mobileSearch ? searchActive : searchInactive]"></div>
</template>

<script>
    export default {
        data() {
            return {
                searchActive: 'search-active        ',
                searchInactive: 'search-inactive'
            }
        },
        computed: {
            mobileSearch() {
                return this.$store.getters.mobileSearch
            }
        }
    }
</script>

<style scoped>
    #green-bar {
        position: fixed;
        left: 0;
        top: 0;
        height: 100vh;
        min-height: 100vh;
        overflow: scroll;
       
        background-color: #51c715;
        z-index: 19;
        padding: 0px 20px 30px 20px;
        transition: all 0.3s ease-in-out;
        overflow-y: hidden;
    }

    .search-inactive {
        width: 380px;
    }

    @media only screen and (max-width: 768px) {
        .search-active {
            width: 100%;
        }

        .search-inactive {
            width: 94%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/GreenBar.vue